import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ThumbnailList } from './thumbnailList';
import { LoadMoreVideos } from './loadMoreVideos';
import { smallMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { translate } from  '../../common/translation/translate';

const ariaId = 'more-featured-videos-section-header';

export const MoreFeaturedVideos  = memo(({ selectVideo }) => {
    return (
        <Container aria-labelledby='more-featured-videos-section-header'>
            <Header id={ariaId}>
                {translate('moreFeaturedVideos')}
            </Header>
            <ThumbsContainer>
                <ThumbnailList
                    selectVideo={selectVideo}
                />
            </ThumbsContainer>
            <LoadMoreVideos />
        </Container>
    );
});

MoreFeaturedVideos.displayName = 'MoreFeaturedVideos';
MoreFeaturedVideos.propTypes = {
    selectVideo: PropTypes.any
};

const Container = styled.section`
    @media ${smallMediaQuery} {
        width: 100%;
    }
`;

const Header = styled.h2`
    font-size: 24px;
    color: #fff;
    font-weight: 600;
    margin-left: 10%;

    @media ${largeMediaQuery} {
        margin-left: 0;
    }
`;

const ThumbsContainer = styled.ul`
    display: grid;
    margin: 0;
    padding: 0;
    grid-template-columns: repeat(auto-fit, 300px);
    grid-auto-rows: minmax(min-content, 250px);
    justify-content: center;
    list-style: none;
    gap: 8px;
`;
